/**
 * Permission-helpers (Порція 3.0.5.5).
 *
 * Базуються на полях `tenant_role` + `permissions[]` з `/auth/me`
 * (додано у Порції 3.0.5.0). Дані беруться з React Query cache (queryKey
 * = `['me']`).
 *
 * Ключова семантика:
 *  - OWNER / ADMIN tenant'а — мають ВСІ permissions автоматично
 *    (backend їх агрегує і повертає у `permissions[]`; також надаємо
 *    шлях fast-path тут — щоб не залежати від конкретного списку).
 *  - MEMBER — лише ті, що повертає backend (агреговано з access_role
 *    через user_access).
 *
 * Контракт у 3.0.5: permissions НЕ enforce'аться на endpoint'ах (це
 * відкладено у 3.0.7). Frontend поводиться так, ніби enforce вже працює
 * — ховає кнопки/посилання. Цей шар захищає UX, не безпеку.
 *
 * Цей модуль НЕ використовує React (легко тестується). React-обгортки
 * — у `RequirePermission.tsx`.
 */
import type { MeResponse } from '@/api/auth';

/** Чи user має дозволений permission. */
export function hasPermission(
  me: Pick<MeResponse, 'tenant_role' | 'permissions'> | undefined,
  code: string,
): boolean {
  if (!me) return false;
  // OWNER/ADMIN — fast path. (Backend і так агрегує усі 49, але дуплікуємо
  // тут для надійності — якщо API колись поверне «компактний» вигляд.)
  if (me.tenant_role === 'OWNER' || me.tenant_role === 'ADMIN') return true;
  return me.permissions.includes(code);
}

/** Чи user має хоча б один з permission codes. */
export function hasAnyPermission(
  me: Pick<MeResponse, 'tenant_role' | 'permissions'> | undefined,
  codes: readonly string[],
): boolean {
  if (!me) return false;
  if (me.tenant_role === 'OWNER' || me.tenant_role === 'ADMIN') return true;
  return codes.some((c) => me.permissions.includes(c));
}
